// Copyright (c) Zammo Inc.
import React, { useEffect, useState } from 'react';

import { InteractionLineWrapper, BrightLine } from './styles';

declare global {
  interface Window {
    webkitAudioContext: typeof AudioContext;
  }
}

interface Props {
  dictating: boolean;
}

const InteractionLine = ({ dictating }: Props) => {
  const [loudness, setLoudness] = useState(0);
  const [track, setTrack] = useState<MediaStreamTrack>();
  useEffect(() => {
    if (dictating) {
      navigator.mediaDevices.getUserMedia({ video: false, audio: true }).then((stream) => {
        setTrack(stream.getTracks()[0]);
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const ctx = new AudioContext();

        if (!ctx) return;

        const mic = ctx.createMediaStreamSource(stream);
        const analyser = ctx.createAnalyser();

        mic.connect(analyser);
        const data = new Uint8Array(analyser.frequencyBinCount);

        function play() {
          analyser.getByteFrequencyData(data);

          // get fullest bin
          let idx = 0;
          for (let j = 0; j < analyser.frequencyBinCount; j++) {
            if (data[j] > data[idx]) {
              idx = j;
            }
          }

          const frequency = (idx * ctx.sampleRate) / analyser.fftSize;
          setLoudness(frequency / 10);
          requestAnimationFrame(play);
        }

        play();
      });
    } else {
      track?.stop();
    }
  }, [dictating]);

  return (
    <InteractionLineWrapper>
      <BrightLine width={loudness} />
    </InteractionLineWrapper>
  );
};

export default InteractionLine;
